(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["st-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('st-product-fit')) {
  customElements.define('st-product-fit', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-fit-open]');
      this.options = Array.from(this.querySelectorAll('[data-fit-size]'));
      if (!this.dialog || !this.options.length) return;
      this.scope = this.closest('.shopify-section') || this.parentElement;
      this.unit = this.unit || 'in';
      this.selected = this.options.find(button => button.getAttribute('aria-pressed') === 'true') || this.options.at(-1);
      this.maxWidth = Math.max(...this.options.map(button => Number(button.dataset.width)));
      this.maxHeight = Math.max(...this.options.map(button => Number(button.dataset.height)));
      this.querySelector('[data-fit-frame]').style.aspectRatio = `${this.maxWidth} / ${this.maxHeight}`;
      const signal = this.controller.signal;
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => this.open(), { signal });
      this.querySelector('[data-fit-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.dialog.addEventListener('close', () => this.unlock(), { signal });
      this.options.forEach(button => button.addEventListener('click', () => { this.selected = button; this.render(true); }, { signal }));
      this.querySelectorAll('[data-fit-unit]').forEach(button => button.addEventListener('click', () => { this.unit = button.dataset.fitUnit; this.render(true); }, { signal }));
      this.querySelector('[data-fit-apply]').addEventListener('click', () => this.apply(), { signal });
      this.render();
    }
    control(button) {
      const pickers = Array.from(this.scope.querySelectorAll('variant-picker')).filter(picker => picker.dataset.productId === this.dataset.productId);
      for (const picker of pickers) {
        const control = Array.from(picker.querySelectorAll('input[data-option-value-id], option[data-option-value-id]')).find(input => input.dataset.optionValueId === button.dataset.optionId);
        if (control) return control;
      }
      return null;
    }
    open() {
      if (this.dialog.open) return;
      this.selected = this.options.find(button => {
        const control = this.control(button);
        return control && (control.checked || control.selected);
      }) || this.selected;
      this.render();
      this.dialog.showModal();
      this.savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
    }
    unlock() {
      if (this.locked) document.documentElement.style.overflow = this.savedOverflow;
      this.locked = false;
      if (this.isConnected) this.trigger.focus({ preventScroll: true });
    }
    render(announce = false) {
      const number = value => (Number(value) * (this.unit === 'cm' ? 2.54 : 1)).toFixed(1);
      this.options.forEach(button => {
        button.setAttribute('aria-pressed', String(button === this.selected));
        button.querySelector('[data-fit-dimensions]').textContent = `${number(button.dataset.width)} × ${number(button.dataset.height)}`;
        button.querySelector('[data-fit-unit-label]').textContent = this.unit;
      });
      this.querySelectorAll('[data-fit-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fitUnit === this.unit)));
      const { width, height } = this.selected.dataset;
      const mat = this.querySelector('[data-fit-mat]');
      mat.style.width = `${Number(width) / this.maxWidth * 100}%`;
      mat.style.height = `${Number(height) / this.maxHeight * 100}%`;
      this.querySelector('[data-fit-width]').textContent = `${number(width)} ${this.unit}`;
      this.querySelector('[data-fit-height]').textContent = `${number(height)} ${this.unit}`;
      const name = this.selected.querySelector('[data-fit-label]').textContent;
      this.querySelector('[data-fit-name]').textContent = name;
      const apply = this.querySelector('[data-fit-apply]');
      const control = this.control(this.selected);
      const available = (control?.dataset.optionAvailable ?? this.selected.dataset.available) !== 'false' && control?.getAttribute('aria-disabled') !== 'true';
      apply.disabled = Boolean(control && !available);
      apply.querySelector('[data-fit-apply-label]').textContent = control ? (available ? apply.dataset.choose.replace('[size]', name) : apply.dataset.unavailable) : apply.dataset.back;
      if (announce) this.querySelector('[data-fit-status]').textContent = `${name}. ${number(width)} × ${number(height)} ${this.unit}.`;
    }
    apply() {
      const control = this.control(this.selected);
      if (this.querySelector('[data-fit-apply]').disabled) return;
      this.dialog.close();
      this.unlock();
      if (!control || control.checked || control.selected) return;
      if (control instanceof HTMLOptionElement) {
        const select = control.closest('select');
        select.value = control.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        control.click();
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
